export const DESKTOP_ILLUSTRATION_WIDTH = 320
export const DESKTOP_ILLUSTRATION_HEIGHT = 299

export const EMPTY_BANNER_SIZE = {
  small: 'small',
  normal: 'normal',
} as const
